// root state object.
// each Vuex instance is just a single state tree.
const state = {
    commentsList: [],
    commentsLists: [
        {
            id: 1,
            body: "first first first first first first first first first first first first first first ",
            edited: false,
            status: true,
            created_at: new Date("2015-12-17"),
            author: {
                id: 1,
                name: 'Ahmed',
            }
        },
        {
            id: 2,
            body: "second",
            edited: false,
            status: true,
            created_at: new Date(),
            author: {
                id: 1,
                name: 'Ahmed',
            }
        },
        {
            id: 3,
            body: "second",
            edited: false,
            status: true,
            created_at: new Date(),
            author: {
                id: 1,
                name: 'Ahmed',
            }
        },
        {
            id: 4,
            body: "second",
            edited: false,
            status: true,
            created_at: new Date(),
            author: {
                id: 1,
                name: 'Ahmed',
            }
        },
        {
            id: 5,
            body: "john's comment",
            edited: false,
            status: true,
            created_at: new Date(),
            author: {
                id: 2,
                name: 'John Doe',
            },
            responses: [
                {
                    body: "ahmed's response",
                    created_at: new Date(),
                    author: {
                        id: 1,
                        name: 'Ahmed R',
                    },
                },
                {
                    body: "ahmed's response",
                    created_at: new Date(),
                    author: {
                        id: 1,
                        name: 'Ahmed R',
                    },
                },
                {
                    body: "ahmed's response",
                    created_at: new Date(),
                    author: {
                        id: 1,
                        name: 'Ahmed R',
                    },
                },
                {
                    body: "ahmed's response",
                    created_at: new Date(),
                    author: {
                        id: 1,
                        name: 'Ahmed R',
                    },
                },
                {
                    body: "ahmed's response",
                    created_at: new Date(),
                    author: {
                        id: 1,
                        name: 'Ahmed R',
                    },
                },
            ]
        }
    ],
    videoMediaId: {
        currentVideoId: 0,
        currentMediaId: 0,
        currentUser: {},
        currentClient: ''
    }
};

function getIndex (array, id) {
  var index = -1;
  array.some(function(element, i) {
    if (element.id === id) {
      index = i;
      return true;
    }
  });
  return index;
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    /**
     * Add comment
     *
     * @function   addComment
     */
    addComment (state, comment) {
        if (state.commentsList.filter(e => e.id === comment.id).length === 0) {
            state.commentsList.push(comment);
        }
    },
    /**
     * set User Name comment
     *
     * @function   addComment
     */
    setUserName (state, user) {
      state.videoMediaId.currentUser = user;
    },
    /**
     * Add response
     *
     * @function   addResponse
     */
    addResponse (state, object) {
        let index = getIndex(state.commentsList, object.comment.id);

        if (state.commentsList[index].responses === undefined) {
            state.commentsList[index].responses = [];
        }
        state.commentsList[index].responses.push(object.response);
    },
    /**
     * Edit comment
     *
     * @function   editComment
     */
    editComment (state, comment) {
        let index = getIndex(state.commentsList, comment.id);
        state.commentsList[index].body = comment.body;
    },
    /**
     * Delete comment
     *
     * @function   deleteComment
     */
    deleteComment (state, commentId) {
        let index = getIndex(state.commentsList, commentId);
        state.commentsList.splice(index, 1);
    },
    /**
     * Disable comment
     *
     * @function   disableComment
     */
    disableComment (state, commentId) {
        let index = getIndex(state.commentsList, commentId);
        state.commentsList[index].status = false;
    },
    /**
     * Enable comment
     *
     * @function   enableComment
     */
    enableComment (state, commentId) {
        let index = getIndex(state.commentsList, commentId);
        state.commentsList[index].status = true;
    },
    /**
     * Changed the content of the comment list
     *
     * @function   updateCommentsList
     */
    updateCommentsList (state, commentsList) {
        state.commentsList = commentsList;
    },
    /**
     * Delete the content of the comment list
     *
     * @function   clearCommentsList
     */
    clearCommentsList (state) {
        state.commentsList = [];
    },
    sortCommentsAsc (state) {
        state.commentsList.sort(function (date1, date2) {
            if (date1.created_at > date2.created_at) return -1;
            if (date1.created_at < date2.created_at) return 1;
            return 0;
        });
    },
    sortCommentsDesc () {
        state.commentsList.sort(function (date1, date2) {
            if (date1.created_at > date2.created_at) return 1;
            if (date1.created_at < date2.created_at) return -1;
            return 0;
        });
    },
    setVideoOptionsComments (state, object) {
        state.videoMediaId.currentVideoId = object.videoId;
        state.videoMediaId.currentMediaId = object.mediaId;
        state.videoMediaId.currentUser    = object.user;
        state.videoMediaId.currentClient  = object.client;
        console.log(state.videoMediaId);
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    addComment: ({ state, commit }, comment) => commit('addComment', comment),
    addResponse: ({ state, commit }, object) => commit('addResponse', object),
    editComment: ({ state, commit }, comment) => commit('editComment', comment),
    deleteComment: ({ state, commit }, commentId) => commit('deleteComment', commentId),
    disableComment: ({ state, commit }, commentId) => commit('disableComment', commentId),
    enableComment: ({ state, commit }, commentId) => commit('enableComment', commentId),
    updateCommentsList: ({ state, commit }, commentsList) => commit('updateCommentsList', commentsList),
    setVideoOptionsComments: ({ state, commit }, videoId) => commit('setVideoOptionsComments', videoId),
    clearCommentsList: ({ commit }) => commit('clearCommentsList'),
    sortCommentsAsc: ({ commit }) => commit('sortCommentsAsc'),
    sortCommentsDesc: ({ commit }) => commit('sortCommentsDesc'),
    setUserName: ({ state, commit }, user) => commit('setUserName', user),
};

// getters are functions
const getters = {
    /**
     * Get getComments
     */
    getComments:  state => state.commentsList,
    /**
     * Get getVideoId
     */
    getVideoId:  state => state.videoMediaId.currentVideoId,
    /**
     * Get getVideoId
     */
    getMediaId:  state => state.videoMediaId.currentMediaId,
    /**
     * Get getClient
     */
    getClient:  state => state.videoMediaId.currentClient,
    /**
     * Get getCurrentUser
     */
    getCurrentUser:  state => state.videoMediaId.currentUser,
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workspace/video-comments.js